import { render, staticRenderFns } from "./naj-tree-node.vue?vue&type=template&id=dcd1b8aa&scoped=true&"
import script from "./naj-tree-node.vue?vue&type=script&lang=js&"
export * from "./naj-tree-node.vue?vue&type=script&lang=js&"
import style0 from "./naj-tree-node.vue?vue&type=style&index=0&id=dcd1b8aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcd1b8aa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
